import { useAlert } from '@/src/components/ui/elements/dialogs/useAlert'
import { useEvent } from 'tamagui'

export function useAlertPaymentProcessingError() {
  const Alert = useAlert(useAlertPaymentProcessingError.name)
  return useEvent((message?: string | null) =>
    Alert.alert('Something went wrong', message || 'There was an error processing your payment'),
  )
}
